/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactHighCharts from 'react-highcharts';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment-timezone';
import _ from 'lodash';
import { translate } from 'react-i18next';
import Highcharts from 'highcharts';
import { placeholderConfig } from '../Highcharts';

const Plot = ReactHighCharts.withHighcharts(Highcharts);

class ExpensesPlot extends Component {
  constructor(props) {
    super(props);

    this.handleEvent = this.handleEvent.bind(this);
  }

  shouldComponentUpdate(props) {
    if (
      this.props.fuelConsumptionReport === props.fuelConsumptionReport &&
      this.props.noRidesEver === props.noRidesEver &&
      this.props.currentLanguage === props.currentLanguage
    ) {
      return false;
    }

    return true;
  }

  getRangeLabel() {
    const [m1, m2] = this.props.range;
    m1.locale(this.props.currentLanguage);
    m2.locale(this.props.currentLanguage);
    return `${m1.format('DD MMMM')} - ${m2.format('DD MMMM YYYY')}`;
  }

  handleEvent(e, picker) {
    this.props.handleEvent(e, picker);
  }

  render() {
    const { t, noRidesEver } = this.props;
    const date = this.props.range[0].format('YYYY,M,D').split(',');
    const start = Date.UTC(date[0], date[1] - 1, date[2]);
    const pointInterval = 86400000;
    const daysCount = this.props.range[1].diff(this.props.range[0], 'days') + 1;
    const journeysDurations = this.props.durationReport.values;
    const journeysCosts = this.props.fuelCostReport.values
      ? this.props.fuelCostReport.values.map(i => Math.round(i))
      : [];
    const journeysDistances = this.props.distanceReport.values
      ? this.props.distanceReport.values.map(
          i => Math.round(i / 1000) * 10 / 10,
        )
      : [];
    const journeysExpenses = this.props.fuelConsumptionReport.values.map(
      (value, index) => ({
        y: Number(value.toFixed(2)),
        ind: [
          journeysDurations[index],
          journeysCosts[index],
          journeysDistances[index],
        ],
        className: value === 0 ? 'disabled' : '',
      }),
    );
    let config = {
      chart: { type: 'column' },
      tooltip: {
        formatter() {
          // eslint-disable-line func-names
          let s = `<div class="tooltipDate">${Highcharts.dateFormat(
            '%e %b %Y',
            this.x,
          )}</div>`;
          for (const point of this.points) {
            let hour = Math.floor(point.point.ind[0] / 3600);
            const days = hour > 23 ? Math.floor(hour / 24) : 0;
            const min = Math.floor((point.point.ind[0] - hour * 3600) / 60);
            if (days > 0) hour -= days * 24;
            let hourHtml;
            const timeText = t('dashboard:time');
            const hrsText = t('dashboard:hours');
            const minText = t('dashboard:mins');
            if (days === 0) {
              hourHtml = `<div class="tooltipWrap">
                            <span class="titile">${timeText}</span>
                            <span>${hour}</span>${hrsText}
                            <span>${min}</span>${minText}
                          </div>`;
            } else if (days > 0 && hour > 0) {
              hourHtml = `<div class="tooltipWrap">
                          <span class="titile">${timeText}</span>
                          <span>${days}</span>
                          ${timeText}
                          <span>${hour}</span>${hrsText}
                          <span>${min}</span>${minText}
                        </div>`;
            } else {
              hourHtml = `<div class="tooltipWrap"><span class="titile">${timeText}</span><span>${min}</span>${minText}</div>`;
            }
            s +=
              `<div class="tooltipWrap active">
                <span>${_.round(point.y, 1)} ${t('dashboard:l')}</span>
               </div>${hourHtml}` +
              `<div class="tooltipWrap"><span class="titile">${t(
                'dashboard:distanceTab',
              )}</span> <span>${point.point.ind[2].toLocaleString('ru')}${t(
                'dashboard:km',
              )}</span></div>`;
          }
          return s;
        },
      },
      plotOptions: {
        series: {
          pointStart: start,
          pointInterval,
        },
      },
      series: [
        {
          name: t('dashboard:timeTab'),
          color: 'rgba(254,84,0,0.4)',
          states: { hover: { color: 'rgba(254,84,0,1)' } },
          data: journeysExpenses,
        },
      ],
    };
    config = noRidesEver ? placeholderConfig(start) : config;
    const totalExpenses = _.round(
      journeysExpenses.reduce((prev, curr) => prev + curr.y, 0),
      1,
    );
    const averageExpensesByDay = _.round(
      journeysExpenses.reduce((prev, curr) => prev + curr.y, 0) / daysCount,
      1,
    );

    return (
      <div id="timeTab" className="tab active">
        <div className="graph-section__status">
          <div className="graph-section__filterWrap">
            <div className="filterBlock">
              <div className="filterBlockDrop">
                <DateRangePicker
                  key={this.props.currentLanguage}
                  onHide={this.handleEvent}
                  startDate={this.props.range[0]}
                  endDate={this.props.range[1]}
                  maxDate={moment()}
                  minDate={moment('01/01/2012', 'DD/MM/YYYY')}
                  alwaysShowCalendars={true} // eslint-disable-line react/jsx-boolean-value
                  showDropdowns={false}
                  showWeekNumbers={false}
                  timePicker={false}
                  ranges={{
                    [t('dashboard:last_7_days')]: [
                      moment().subtract(6, 'days'),
                      moment(),
                    ],
                    [t('dashboard:last_30_days')]: [
                      moment().subtract(29, 'days'),
                      moment(),
                    ],
                    [t('dashboard:last_90_days')]: [
                      moment().subtract(89, 'days'),
                      moment(),
                    ],
                  }}
                  showCustomRangeLabel={false}
                  opens={'left'}
                  format={'DD.MM.YYYY'}
                  locale={{
                    format: 'DD.MM.YYYY',
                    customRangeLabel: 'Custom Range',
                    firstDay: 1,
                  }}
                  dateLimit={{ days: 90 }}
                >
                  <div className="pull-right reportrange">
                    <span>{this.getRangeLabel()}</span>
                    <b className="caret" />
                  </div>
                </DateRangePicker>
              </div>
            </div>
          </div>
          <div className="graph-section__filterInfo">
            <div className="graph-section__filterInfo__col">
              <div className="status">
                {averageExpensesByDay}
                {t('dashboard:l')}
              </div>
              <div className="title">{t('dashboard:average')}</div>
            </div>
            <div className="graph-section__filterInfo__col">
              <div className="status">
                {totalExpenses}
                {t('dashboard:l')}
              </div>
              <div className="title">{t('dashboard:total')}</div>
            </div>
          </div>
        </div>
        <Plot
          config={config}
          domProps={{
            id: 'sectionGraphDrivingTime',
            className: 'graph-section__graph',
          }}
        />
      </div>
    );
  }
}

ExpensesPlot.PropTypes = {
  fuelConsumptionReport: PropTypes.object,
  fuelCostReport: PropTypes.object,
  durationReport: PropTypes.object,
  distanceReport: PropTypes.object,
  range: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
  handleEvent: PropTypes.func,
};

export default translate(['dashboard'], { wait: true })(
  connect(state => ({
    noRidesEver: !(
      !state.rides.areJourneysEverLoaded || state.rides.areJourneysEverExist
    ),
    fuelConsumptionReport:
      state.dashboard.filteredReports.fuelConsumptionReport,
    fuelCostReport: state.dashboard.filteredReports.fuelCostReport,
    durationReport: state.dashboard.filteredReports.durationReport,
    distanceReport: state.dashboard.filteredReports.distanceReport,
    currentLanguage: state.langs.currentLanguage,
  }))(ExpensesPlot),
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Plots/ExpensesPlot.js